import styled from "styled-components";

export const TransparentLink = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {
    color: inherit;
  }

  &:visited {
    color: inherit;
  }
`;
